import DefaultScreen from "@components/Global/DefaultScreenView"
import AnimateTextEntry from "@hooks/animateTextEntry";
import { useRoute } from "@react-navigation/native";
import { ScrollView } from "react-native";
import { Paragraph, H5, View, Separator, SizableText, YStack } from "tamagui";

const CoursesScreen = () => {
  const { params } = useRoute();
  const { title, description } = params?.params;

  return (
    <DefaultScreen backButton noMargin scrollDisabled style={{ paddingHorizontal: 20, paddingBottom: 140, width: "100%", flex: 1 }}>
      <View flex={1} minWidth={"100%"} paddingBottom={40}>
        <YStack paddingLeft={50} top={-20}>
          <H5 color={"black"} >Course: {title}</H5>
          <Paragraph>{description}</Paragraph>
          <Separator borderColor="white" paddingBottom={20} />
        </YStack>
        <ScrollView style={{ flex: 10 }} showsVerticalScrollIndicator={false} contentContainerStyle={{paddingVertical: 40}}>
          <SizableText>
            Absolutely! Here's a concise and engaging written content draft for a course titled "Marketing 101" — perfect for your app, landing page, or course overview:

            Marketing 101: Master the Foundations of Modern Marketing
            Overview:

            Whether you're a budding entrepreneur, a startup founder, or just curious about how brands grow, Marketing 101 gives you the essential tools to understand the core principles that drive successful marketing strategies.

            What You'll Learn:

            📚 The 4 Ps of Marketing: Product, Price, Place, Promotion — and how to apply them in real-world scenarios.

            🔍 Identifying Your Target Audience: Learn how to define, segment, and reach the right people for your product or service.

            💡 Crafting a Compelling Value Proposition: Understand what makes a brand stand out in a noisy market.

            📈 Introduction to Digital Marketing: Basics of SEO, social media, email marketing, and paid ads.

            🤝 Building Brand Trust: Explore storytelling, branding, and how consistency drives customer loyalty.

            Why It Matters:

            Marketing isn’t just about selling — it’s about solving problems, communicating value, and creating lasting connections with your audience. This course lays a solid foundation for anyone looking to confidently step into the world of marketing.

            Perfect For:

            Startup founders & solo entrepreneurs

            New marketers or interns

            Small business owners

            Anyone curious about how marketing really works

            Let me know if you want a more casual, academic, or product-focused tone — or a shorter version for mobile view!</SizableText>

        </ScrollView>
      </View>
    </DefaultScreen>
  )
}
export default CoursesScreen;